import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { MyProgram } from '@app/models/system/my-program.model';
import { getPageHeadingChild, getPageHeadingChildren, getPageHeadingData, getPathname, PageHeadingState } from '@app/selectors/page-heading.selector';
import { Node } from '@app/models/components/node.model';
import { LangConstant } from '@app/common/constant/lang.constant';
import { CommonUtils } from '@app/common/util/common.util';
import { environment } from '@enviroments/environment';
import { AuthUtil } from '@app/common/util/auth.util';
import { ConvertUtil } from '@app/common/util/convert.util';

@Component({
  selector: 'hp-page-heading',
  templateUrl: './page-heading.component.html',
  styleUrls: ['./page-heading.component.css']
})
export class PageHeadingComponent implements OnInit {

  parent$ = new Observable<MyProgram>();
  child$ = new Observable<MyProgram>();
  children$ = new Observable<Node<MyProgram>[]>();
  pathname$ = new Observable<string>();

  pathname: string = "";
  parent: MyProgram = {} as MyProgram;
  child: MyProgram = {} as MyProgram;
  children: Node<MyProgram>[] = [] as Node<MyProgram>[];

  lang: string = environment.default_lang;

  userKind: string = '';
  useridTest: string = '';

  isLogined: boolean = false;

  constructor(private _pageHeadingStore: Store<PageHeadingState>) {
    this.parent$ = this._pageHeadingStore.select(getPageHeadingData);
    this.child$ = this._pageHeadingStore.select(getPageHeadingChild);
    this.children$ = this._pageHeadingStore.select(getPageHeadingChildren);
    this.pathname$ = this._pageHeadingStore.select(getPathname);
  }

  ngOnInit(): void { 
    if(AuthUtil.isLogined()){
      let member = AuthUtil.getLoginedInfo();
      this.useridTest = ConvertUtil.convertToSring(member?.userid);
      this.userKind = ConvertUtil.convertToSring(member?.userKind).substr(3, 3);
    }

    this.parent$.subscribe(res => {
      this.parent = res;
    });

    this.child$.subscribe(res => {
      this.pathname = window.location.pathname;

      this.child = res;
    });

    this.children$.subscribe(res => {
      this.children = res;
    })

    this.pathname$.subscribe(res => this.pathname = res);

    this.handleOnActiveLangItem();

    if (AuthUtil.isLogined()) {
      this.isLogined = true;
    } else {
      this.isLogined = false;
    }
  }

  handleOnActiveLangItem(): void {
    const tm = setInterval(() => {
      const lang = sessionStorage.getItem(LangConstant.STR_LANG);
      if (lang) {
        this.lang = CommonUtils.getLangMessage();
        clearInterval(tm);
      }
    }, 100);
  }
}
